import Vue from 'vue'
import App from './App.vue'
import router from './router'
Vue.config.productionTip = false
const baseSize = 16
function setRem () {
    const scale = document.documentElement.clientWidth / 1920
    document.documentElement.style.fontSize = baseSize * Math.min(scale, 2) + 'px'
}
setRem()
window.onresize = function () {
  setRem()
}

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
